// extracted by mini-css-extract-plugin
export var icon = "discount-label-module--icon--6FyuU";
export var text = "discount-label-module--text--yaies";
export var wrapper = "discount-label-module--wrapper--hHapK";